import { styled } from '@mui/material';

export const StyledContainer = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: '100px',
    paddingTop: '100px',
  };
});

export const StyledTitle = styled('div')(() => {
  return {
    paddingBottom: '8px',
  };
});

export const StyledCardsWrapper = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    gap: '12px',
    paddingTop: '60px',
    flexWrap: 'wrap',
  };
});

export const StyledTwoCards = styled('div')(() => {
  return {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    flex: 1,
    gap: 12,
  };
});
